import $ from 'jquery/src/jquery';

export default () => {
    function init() {
        if (!$('a[href^="#"]').length) {
            return
        }

        initAnchor()
    }

    function initAnchor() {
        $(document).on('click', 'a', function (event) {
            let url = $(this).attr('href');
            let hrefWithoutHash = url.split('#')[0];

            if( url.indexOf('#') >= 0 && hrefWithoutHash === location.href.split('#')[0] ) {
                let hash = url.substring(url.indexOf('#'));

                if( $(hash).length ) {
                    event.preventDefault()
                    let target = $(hash).offset().top
                    if ( window.innerWidth < 1024 ) {
                        target -= 58;
                    }
                    $("html, body").animate({ scrollTop: target }, "slow");
                }
            }
        });
    }

    return Object.freeze({
        init,
    })
}